import classNames from 'classnames'
import { ReactComponent as PlusIcon } from '@svgs/keyline/add.svg'
import { ReactComponent as MinusIcon } from '@svgs/keyline/minus.svg'
import styles from './styles.module.scss'
import Translations from '@helpers/translations'

type QuantitySelectorProps = {
  value: number
  onChange: (newValue: number) => void
  min?: number
  max?: number
  inventoryQuantity?: number
  step?: number
  size?: 'small' | 'large'
  disabled?: boolean
  error?: boolean
}

export function QuantitySelector({
  error,
  value,
  inventoryQuantity,
  onChange,
  min = 1,
  max = Infinity,
  step = 1,
  size = 'small',
  disabled = false
}: QuantitySelectorProps) {
  const increment = () => {
    if (!disabled && value + step <= max) {
      onChange(value + step)
    }
  }

  const decrement = () => {
    if (!disabled && value - step >= min) {
      onChange(value - step)
    }
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(e.target.value)
    if (!isNaN(newValue) && newValue >= min && newValue <= max) {
      onChange(newValue)
    }
  }

  const errors = error
    ? {
        message: `${inventoryQuantity} ${Translations.localise(
          'pages.cart.in-stock'
        )}`
      }
    : null

  return (
    <div className={classNames(styles.QuantitySelector, styles[size])}>
      <div className={styles.controls}>
        <button
          type="button"
          onClick={decrement}
          disabled={disabled || value <= min}
        >
          <MinusIcon />
        </button>

        <input
          type="number"
          value={value}
          onChange={handleInputChange}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
        />

        <button
          type="button"
          onClick={increment}
          disabled={disabled || value >= max}
        >
          <PlusIcon />
        </button>
      </div>
      {errors && <p className={styles.errorText}>{errors?.message}</p>}
    </div>
  )
}
